import { __assign } from 'tslib';
import * as React from 'react';

var SvgSearch = function SvgSearch(props) {
  return React.createElement("svg", __assign({
    "data-name": "Icon - Search",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 120 120.237"
  }, props), React.createElement("path", {
    fill: "none",
    d: "M0 .237h120v120H0z"
  }), React.createElement("g", {
    transform: "translate(4899.631 7684.959)"
  }, React.createElement("path", {
    "data-name": "Path 1565",
    d: "M-4779.67-7577.424v-.011a5.5 5.5 0 0 0-.119-.629c-.043-.185-.1-.377-.157-.574l-.035-.108a11.01 11.01 0 0 0-.221-.623l-.02-.049a14.278 14.278 0 0 0-.273-.641l-.041-.093a14.3 14.3 0 0 0-.335-.686l-.067-.131a25.743 25.743 0 0 0-.394-.724l-.048-.083c-.138-.24-.283-.483-.435-.732l-.056-.091q-.238-.384-.5-.782c-.034-.052-.069-.1-.1-.157a36.545 36.545 0 0 0-.551-.806l-.085-.119q-.283-.4-.588-.813l-.06-.081-.2-.265v-.008l-.041-.053a53.05 53.05 0 0 0-.416-.542l-.134-.172-.486-.613-.05-.063-.163-.2-.123-.149q-.363-.445-.746-.9l-.045-.054-.1-.116-.069-.08q-.315-.37-.645-.745l-.16-.183-.422-.475-.113-.125-.3-.333-.164-.18c-.3-.328-.6-.658-.919-.991-7.3-7.75-24.6-18.5-24.6-18.5l-.244-.124-.129-.066-.192-.1-.153-.08-.226-.116-.256-.132-.176-.092-.227-.118-.285-.148-.22-.114-.285-.149-.343-.179-.208-.108-.331-.173-.28-.147-.3-.159-.282-.147-.378-.2-.229-.12-.316-.166-.3-.159-.487-.255-.019-.01-.436-.229c-.092-.048-.184-.1-.274-.144l-.259-.135a69.483 69.483 0 0 1-.922-.539 78.944 78.944 0 0 1-2.972-1.876c-.7-.479-1.415-.974-2.029-1.4a39.157 39.157 0 0 0 4.145-17.576c0-.555-.018-1.1-.041-1.653.023-.548.041-1.1.041-1.652 0-.185-.011-.367-.014-.551s.014-.366.014-.551a38.853 38.853 0 0 0-38.672-39.031 38.853 38.853 0 0 0-38.673 39.031c0 .185.012.367.014.551s-.014.366-.014.551c0 .554.019 1.1.042 1.652-.023.549-.042 1.1-.042 1.653a38.853 38.853 0 0 0 38.673 39.031 38.4 38.4 0 0 0 28.331-12.476c1.643 1.281 3.829 3 4.462 3.59l.027-.036a71.5 71.5 0 0 1 6 5.787s14.317 14.492 24.787 19.813c13.05 6.649 18.204 6.208 17.659 1.932Zm-81.288-87.337a29.7 29.7 0 0 1 29.609 27.5 29.7 29.7 0 0 1-29.609 27.5 29.7 29.7 0 0 1-29.61-27.5 29.7 29.7 0 0 1 29.61-27.5Z",
    opacity: 0.3
  }), React.createElement("path", {
    "data-name": "Path 1566",
    d: "M-4860.958-7680.553a38.853 38.853 0 0 0-38.673 39.031 38.853 38.853 0 0 0 38.673 39.032 38.853 38.853 0 0 0 38.672-39.032 38.853 38.853 0 0 0-38.672-39.031Zm0 68.731a29.7 29.7 0 0 1-29.7-29.7 29.7 29.7 0 0 1 29.7-29.7 29.7 29.7 0 0 1 29.7 29.7 29.7 29.7 0 0 1-29.7 29.7Z",
    fill: "#ca6e14"
  }), React.createElement("path", {
    "data-name": "Path 1567",
    d: "M-4855.664-7612.3a29.828 29.828 0 0 1-5.294.48 29.7 29.7 0 0 1-29.7-29.7 29.7 29.7 0 0 1 29.7-29.7 29.92 29.92 0 0 1 5.294.479v-9.438a38.72 38.72 0 0 0-5.294-.373 38.853 38.853 0 0 0-38.673 39.031 38.853 38.853 0 0 0 38.673 39.032 38.565 38.565 0 0 0 5.294-.374Z",
    fill: "#d9751a",
    fillRule: "evenodd"
  }), React.createElement("g", {
    "data-name": "Group 1551"
  }, React.createElement("g", {
    "data-name": "Group 1550"
  }, React.createElement("g", {
    "data-name": "Group 1549"
  }, React.createElement("path", {
    "data-name": "Path 1568",
    d: "M-4789.061-7598.065c-7.3-7.75-24.6-18.5-24.6-18.5-.741-.373-4.458-2.129-7.765-4.106-3.573-2.136-6.724-4.49-6.724-4.49l-6.409 8.688s3.28 2.342 6.4 5.031a71.531 71.531 0 0 1 6.026 5.813s14.317 14.492 24.787 19.813c22.583 11.485 21.529 1.816 8.285-12.249Z",
    fill: "#642681"
  }), React.createElement("path", {
    "data-name": "Path 1569",
    d: "M-4813.665-7616.561c-1.115-.56-5.792-3.014-8.3-4.332l-4.321 6.933s45.624 39.749 46.617 30.075c-.4-3.113-3.813-8.257-9.391-14.18-7.299-7.75-24.605-18.496-24.605-18.496Z",
    fill: "#931d80"
  }), React.createElement("path", {
    "data-name": "Path 1570",
    d: "M-4813.665-7616.561c-1.079-.542-5.494-2.858-8.052-4.2l-1.2 2.246s48.241 42.35 39.831 27.906q-.441-.758-.88-1.481a72.813 72.813 0 0 0-5.1-5.974c-7.293-7.751-24.599-18.497-24.599-18.497Z",
    fill: "#e62074"
  }), React.createElement("path", {
    "data-name": "Path 1571",
    d: "M-4834.563-7616.469s5.346 4.12 6.4 5.093l6.775-9.215c-1.273-.669-6.764-4.566-6.764-4.566Z",
    fill: "#f8af3c"
  }), React.createElement("path", {
    "data-name": "Path 1572",
    d: "m-4829.427-7623.431 6.512 4.915 1.525-2.075c-1.273-.669-6.764-4.566-6.764-4.566Z",
    fill: "#f8e831"
  }), React.createElement("path", {
    "data-name": "Path 1573",
    d: "M-4834.563-7616.469s5.346 4.12 6.4 5.093l1.962-2.668-6.668-4.613-.061-.023Z",
    fill: "#f29222"
  })))), React.createElement("circle", {
    "data-name": "Ellipse 388",
    cx: 29.7,
    cy: 29.7,
    r: 29.7,
    transform: "translate(-4890.658 -7674.526)",
    fill: "#c7e7fa",
    opacity: 0.7
  }), React.createElement("path", {
    "data-name": "Path 1574",
    d: "M-4860.958-7684.959a38.852 38.852 0 0 0-38.673 39.031 38.853 38.853 0 0 0 38.673 39.031 38.853 38.853 0 0 0 38.672-39.031 38.852 38.852 0 0 0-38.672-39.031Zm0 68.73a29.7 29.7 0 0 1-29.7-29.7 29.7 29.7 0 0 1 29.7-29.7 29.7 29.7 0 0 1 29.7 29.7 29.7 29.7 0 0 1-29.7 29.7Z",
    fill: "#f8e831"
  }), React.createElement("path", {
    "data-name": "Path 1575",
    d: "M-4860.958-7683.858a38.853 38.853 0 0 0-38.673 39.031 38.853 38.853 0 0 0 38.673 39.032 38.853 38.853 0 0 0 38.672-39.032 38.853 38.853 0 0 0-38.672-39.031Zm0 68.731a29.7 29.7 0 0 1-29.7-29.7 29.7 29.7 0 0 1 29.7-29.7 29.7 29.7 0 0 1 29.7 29.7 29.7 29.7 0 0 1-29.7 29.7Z",
    fill: "#f8af3c"
  }), React.createElement("path", {
    "data-name": "Path 1576",
    d: "M-4864.712-7658.743a26.973 26.973 0 0 0 .14 38.155 26.837 26.837 0 0 0 7.44 5.2 29.587 29.587 0 0 1-24.663-8.36 29.715 29.715 0 0 1-.166-42.028 29.713 29.713 0 0 1 41.73-.414 26.957 26.957 0 0 0-24.481 7.447Z",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.4
  })));
};

export { SvgSearch as default };